import React from "react"
import SbEditable from "storyblok-react"
import Components from "../index"
import { StyledGrid } from "./partials"

const GridV2 = ({ blok }) => (
  <SbEditable content={blok}>
    <StyledGrid
      guttersWide={blok.gutters_wide}
      guttersDesktop={blok.gutters_desktop}
      guttersTablet={blok.gutters_tablet}
      guttersMobile={blok.gutters_mobile}
      columnsWide={blok.columns_wide}
      columnsDesktop={blok.columns_desktop}
      columnsTablet={blok.columns_tablet}
      columnsMobile={blok.columns_mobile}
    >
      {blok.item &&
        blok.item.map((content) =>
          React.createElement(Components(content.component), {
            key: content._uid,
            blok: content,
          })
        )}
    </StyledGrid>
  </SbEditable>
)

export default GridV2
